import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from 'components/Layout';
import Dashboard from 'components/Dashboard/Dashboard';
import SegmentationLabels from 'components/SegmentationLabels/SegmentationLabels';
import Predictions from 'components/Predictions/Predictions';
import Settings from 'components/Settings/Settings';
import Login from 'components/Login/Login';
import DevShowcase from 'components/DevShowcase';
import TokenHandler from 'components/TokenHandler';
import PrivateRoute from 'components/PrivateRoute';
import { UserProvider } from 'services/providers';
import { UserContext } from 'services/contexts';
import { ConfigProvider } from 'antd';
import { COLORS } from 'theme';
import Keypoints from 'components/KeypointCollectionLabels/Keypoints';
import SegmentationPredictions from 'components/SegmentationPredictions/SegmentationPredictions';
import ViewLabels from 'components/ViewLabels/ViewLabels';
import FrameReview from 'components/FrameReview/FrameReview';
import ThreeDStudyViewer from 'components/ThreeDStudyViewer';

const App: React.FC = () => {
  const [checking, setChecking] = useState(true);

  return (
    <UserProvider>
      <UserContext.Consumer>
        {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
        {({ user }) => (
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: COLORS.primary,
              },
              components: {
                Layout: {
                  bodyBg: 'aliceblue',
                },
              },
            }}
          >
            <BrowserRouter>
              <TokenHandler onDone={() => setChecking(false)} />
              {!checking && (
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <Layout />
                      </PrivateRoute>
                    }
                  >
                    <Route index element={<Dashboard />} />
                    <Route path="segmentation-labels" element={<SegmentationLabels />} />
                    <Route path="segmentation-predictions" element={<SegmentationPredictions />} />
                    <Route path="keypoints" element={<Keypoints />} />
                    <Route path="view-labels" element={<ViewLabels />} />
                    <Route path="frame-review" element={<FrameReview />} />
                    <Route path="3d-study-viewer/:studyIcid?" element={<ThreeDStudyViewer />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="Predictions" element={<Predictions />} />
                    {process.env.REACT_APP_SHOW_DEV_SHOWCASE === 'true' && (
                      <>
                        <Route path="dev-showcase" element={<DevShowcase />} />
                      </>
                    )}
                  </Route>
                  <Route path="*" element={<Layout />} />
                </Routes>
              )}
            </BrowserRouter>
          </ConfigProvider>
        )}
      </UserContext.Consumer>
    </UserProvider>
  );
};

export default App;
